import { useLocation } from 'react-router-dom';

/**
 * 尚未实现的页面占位（`nav.ts` 里已可见、但所属阶段还没到）。
 *
 * **为什么需要它**：`nav.ts` 声明了 `/orders`、`/ledger`、`/settlements`、`/reports`、
 * `/members`、`/settings` 六个入口，而 Phase 3 的 `router.tsx` 里没有对应路由——
 * react-router 对未匹配的子路由渲染**空白内容区**，菜单点得动却什么都没有，
 * 用户分不清「没做」和「坏了」。占位页把「还没做」说出来，并显示当前路径便于对照，
 * 比空白诚实，也能被测试断言住（`nav.spec.ts` 有一条「每个 nav 的 to 都有路由」）。
 *
 * 真正实现各自页面时，把 `router.tsx` 里那条路由的 element 换掉、删掉本文件即可。
 */
export default function NotImplementedPage() {
  const { pathname } = useLocation();

  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-2xl font-bold text-gray-900">该页面尚未实现</h1>
      <p className="text-gray-600">
        当前路径：<code className="rounded bg-gray-100 px-1.5 py-0.5">{pathname}</code>
      </p>
      <p className="text-sm text-gray-500">这个入口会在后续阶段交付，暂不提供功能。</p>
    </div>
  );
}
